import { render, staticRenderFns } from "./tmp-bulletins.vue?vue&type=template&id=c88564e4&"
import script from "./tmp-bulletins.vue?vue&type=script&lang=js&"
export * from "./tmp-bulletins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports